import {
  CheckInRule,
  CheckInRuleDate,
  CheckInRulePenalty,
  MAX_CHECKIN_RULE_DAYS,
} from '../components/sites/site/site-customization/policies/policies.types'
import {
  // AcceptedCards,
  nameResultsOrder,
} from '../components/sites/property.types'
import { ChargeType } from '../components/sites/site/site-customization/policies/taxAndFees.types'
import { Role } from '../components/auth/auth.types'
import { RestrictionType } from '../components/sites/site/restrictions/restriction.types'

export type ViewItems = 'card' | 'table'
export type OrderBy = 'asc' | 'desc'

export function isSiteIdParam(
  param: Record<string, string>
): param is Record<'siteId', string> {
  return 'siteId' in param
}

export function isUserIdParam(
  param: Record<string, string>
): param is Record<'userId', string> {
  return 'userId' in param
}

export type APIResponse<T> = {
  data: T
  message: string
  success: boolean
}

export type APIError<T> = {
  message: string
  errors: T[]
  status: 'error'
}

export type CsvImportRowError = {
  rowNumber: number
  message: string
}

export type CsvImportResultData = {
  fileName?: string
  totalRows?: number
  rowsWithUpdates?: number
  rowsWithErrors?: number
  updatedRows?: number
  errors?: CsvImportRowError[]
}

export type CsvImportResponse = {
  success: boolean
  message: string
  code?: string
  data: CsvImportResultData
}

/** Returns the partial-failure payload when the import saved some rows but
 *  rejected others (HTTP 200 with success:false), otherwise null. */
export const getCsvImportRowErrors = (
  response: CsvImportResponse | undefined
): CsvImportResultData | null => {
  const errors = response?.data?.errors
  return Array.isArray(errors) && errors.length > 0 ? response!.data : null
}

export enum Days {
  'Monday' = 'Monday',
  'Tuesday' = 'Tuesday',
  'Wednesday' = 'Wednesday',
  'Thursday' = 'Thursday',
  'Friday' = 'Friday',
  'Saturday' = 'Saturday',
  'Sunday' = 'Sunday',
  'All' = 'All',
}

export enum Times {
  '00:00:00' = '00:00:00',
  '00:30:00' = '00:30:00',
  '01:00:00' = '01:00:00',
  '01:30:00' = '01:30:00',
  '02:00:00' = '02:00:00',
  '02:30:00' = '02:30:00',
  '03:00:00' = '03:00:00',
  '03:30:00' = '03:30:00',
  '04:00:00' = '04:00:00',
  '04:30:00' = '04:30:00',
  '05:00:00' = '05:00:00',
  '05:30:00' = '05:30:00',
  '06:00:00' = '06:00:00',
  '06:30:00' = '06:30:00',
  '07:00:00' = '07:00:00',
  '07:30:00' = '07:30:00',
  '08:00:00' = '08:00:00',
  '08:30:00' = '08:30:00',
  '09:00:00' = '09:00:00',
  '09:30:00' = '09:30:00',
  '10:00:00' = '10:00:00',
  '10:30:00' = '10:30:00',
  '11:00:00' = '11:00:00',
  '11:30:00' = '11:30:00',
  '12:00:00' = '12:00:00',
  '12:30:00' = '12:30:00',
  '13:00:00' = '13:00:00',
  '13:30:00' = '13:30:00',
  '14:00:00' = '14:00:00',
  '14:30:00' = '14:30:00',
  '15:00:00' = '15:00:00',
  '15:30:00' = '15:30:00',
  '16:00:00' = '16:00:00',
  '16:30:00' = '16:30:00',
  '17:00:00' = '17:00:00',
  '17:30:00' = '17:30:00',
  '18:00:00' = '18:00:00',
  '18:30:00' = '18:30:00',
  '19:00:00' = '19:00:00',
  '19:30:00' = '19:30:00',
  '20:00:00' = '20:00:00',
  '20:30:00' = '20:30:00',
  '21:00:00' = '21:00:00',
  '21:30:00' = '21:30:00',
  '22:00:00' = '22:00:00',
  '22:30:00' = '22:30:00',
  '23:00:00' = '23:00:00',
  '23:30:00' = '23:30:00',
}

export const TimesOptions = [
  { value: '00:00:00', label: '00:00' },
  { value: '00:30:00', label: '00:30' },
  { value: '01:00:00', label: '01:00' },
  { value: '01:30:00', label: '01:30' },
  { value: '02:00:00', label: '02:00' },
  { value: '02:30:00', label: '02:30' },
  { value: '03:00:00', label: '03:00' },
  { value: '03:30:00', label: '03:30' },
  { value: '04:00:00', label: '04:00' },
  { value: '04:30:00', label: '04:30' },
  { value: '05:00:00', label: '05:00' },
  { value: '05:30:00', label: '05:30' },
  { value: '06:00:00', label: '06:00' },
  { value: '06:30:00', label: '06:30' },
  { value: '07:00:00', label: '07:00' },
  { value: '07:30:00', label: '07:30' },
  { value: '08:00:00', label: '08:00' },
  { value: '08:30:00', label: '08:30' },
  { value: '09:00:00', label: '09:00' },
  { value: '09:30:00', label: '09:30' },
  { value: '10:00:00', label: '10:00' },
  { value: '10:30:00', label: '10:30' },
  { value: '11:00:00', label: '11:00' },
  { value: '11:30:00', label: '11:30' },
  { value: '12:00:00', label: '12:00' },
  { value: '12:30:00', label: '12:30' },
  { value: '13:00:00', label: '13:00' },
  { value: '13:30:00', label: '13:30' },
  { value: '14:00:00', label: '14:00' },
  { value: '14:30:00', label: '14:30' },
  { value: '15:00:00', label: '15:00' },
  { value: '15:30:00', label: '15:30' },
  { value: '16:00:00', label: '16:00' },
  { value: '16:30:00', label: '16:30' },
  { value: '17:00:00', label: '17:00' },
  { value: '17:30:00', label: '17:30' },
  { value: '18:00:00', label: '18:00' },
  { value: '18:30:00', label: '18:30' },
  { value: '19:00:00', label: '19:00' },
  { value: '19:30:00', label: '19:30' },
  { value: '20:00:00', label: '20:00' },
  { value: '20:30:00', label: '20:30' },
  { value: '21:00:00', label: '21:00' },
  { value: '21:30:00', label: '21:30' },
  { value: '22:00:00', label: '22:00' },
  { value: '22:30:00', label: '22:30' },
  { value: '23:00:00', label: '23:00' },
  { value: '23:30:00', label: '23:30' },
]

export enum DaysSettings {
  'allDays' = 'allDays',
  'specificDays' = 'specificDays',
}

export const CheckInRuleOptions = [
  {
    value: CheckInRule['Non-Cancellable'],
    label: 'policies.checkInRuleDate.nonCancellable',
  },
  { value: CheckInRule.Cancel, label: 'common.cancel' },
]

export const CheckInRuleDateOptions: {
  value: number
  label: string
  days?: number
}[] = [
  {
    value: CheckInRuleDate['Day Before'],
    label: 'policies.checkInRuleDate.dayBefore',
  },
  ...Array.from({ length: MAX_CHECKIN_RULE_DAYS - 1 }, (_, index) => {
    const days = index + 2
    return {
      value: days,
      label: 'policies.checkInRuleDate.beforeNDays',
      days,
    }
  }),
]

export const CheckInRulePenaltyOptions = [
  {
    value: CheckInRulePenalty['Value of first night'],
    label: 'policies.valueOfFirstNight',
  },
  { value: CheckInRulePenalty['No Penalty'], label: 'policies.noPenalty' },
  {
    value: CheckInRulePenalty['Percentage of booking total'],
    label: 'policies.percentageOfBookingTotal',
  },
  { value: CheckInRulePenalty['Fixed amount'], label: 'policies.fixedAmount' },
]

/**
 * Message id per penalty, including 'Entire Amount' which is not selectable in
 * the penalty dropdowns (it comes from the Non-Cancellable default rule) but
 * still has to be named in summaries.
 */
export const CheckInRulePenaltyLabels: Record<CheckInRulePenalty, string> = {
  ...(Object.fromEntries(
    CheckInRulePenaltyOptions.map((opt) => [opt.value, opt.label])
  ) as Record<CheckInRulePenalty, string>),
  [CheckInRulePenalty['Entire Amount']]: 'policies.entireAmount',
}

export const ChargeTypeOptions = [
  { value: ChargeType.Percentage, label: 'common.percentage' },
  { value: ChargeType['Fixed Amount'], label: 'policies.fixedAmount' },
]

export const TaxTypeRulesOptions = [
  { value: 'Bed Tax', label: 'taxTypes.bedTax' },
  { value: 'City Fee', label: 'taxTypes.cityFee' },
  { value: 'City Tax', label: 'taxTypes.cityTax' },
  { value: 'County Tax', label: 'taxTypes.countyTax' },
  { value: 'Energy Tax', label: 'taxTypes.energyTax' },
  { value: 'Federal Tax', label: 'taxTypes.federalTax' },
  { value: 'Food & Beverage Tax', label: 'taxTypes.foodAndBeverageTax' },
  { value: 'Lodging Tax', label: 'taxTypes.lodgingTax' },
  { value: 'Maintenance Fee', label: 'taxTypes.maintenanceFee' },
  { value: 'Occupancy Tax', label: 'taxTypes.occupancyTax' },
  { value: 'Package Fee', label: 'taxTypes.packageFee' },
  { value: 'Resort Fee', label: 'taxTypes.resortFee' },
  { value: 'Sales Tax', label: 'taxTypes.salesTax' },
  { value: 'Service Tax', label: 'taxTypes.serviceTax' },
  { value: 'State Tax', label: 'taxTypes.stateTax' },
  { value: 'Tourism Tax', label: 'taxTypes.tourismTax' },
  { value: 'Room Tax', label: 'taxTypes.roomTax' },
  { value: 'Room Service Fee', label: 'taxTypes.roomServiceFee' },
  { value: 'Local Fee', label: 'taxTypes.localFee' },
  { value: 'Value Added Tax (VAT)', label: 'taxTypes.valueAddedTax' },
  { value: 'Other Tax', label: 'taxTypes.other' },
  { value: 'Other Fee', label: 'taxTypes.otherFee' },
]

// Quantifiers are grouped by the scope they apply to. 'Item Value' applies to
// both scopes, but it is listed once in an unlabeled leading group instead of
// in both groups: Radix Select portals the text of every item whose value
// matches the selection into the trigger, so a duplicated value would render
// its label twice.
export const QuantifierOptions: {
  group: string | null
  options: { value: string; label: string }[]
}[] = [
  {
    group: null,
    options: [{ value: 'Item Value', label: 'policies.perItemValue' }],
  },
  {
    // Rooms and add-ons
    group: 'Rate',
    options: [
      { value: 'Per Room Night', label: 'policies.perRoomNight' },
      { value: 'Per Room Reservation', label: 'policies.perRoomReservation' },
      { value: 'Per Transaction', label: 'policies.perTransaction' },
      { value: 'Per Adult', label: 'policies.perAdult' },
      { value: 'Per Child', label: 'policies.perChild' },
      { value: 'Per Adult Per Night', label: 'policies.perAdultPerNight' },
      { value: 'Per Child Per Night', label: 'policies.perChildPerNight' },
      { value: 'Per Person Per Night', label: 'policies.perPersonPerNight' },
    ],
  },
  {
    group: 'Activity/Product',
    options: [
      { value: 'Per Item', label: 'policies.perItem' },
      { value: 'Per Person', label: 'policies.perPerson' },
      {
        value: 'Per Activity/Product Transaction',
        label: 'policies.perActivityProductTransaction',
      },
    ],
  },
]

export const nameResultsOrderOptions = [
  {
    value: nameResultsOrder['Rate, Room, Activities'],
    label: 'siteCustom.RateRoomActivities',
  },
  {
    value: nameResultsOrder['Room, Rate, Activities'],
    label: 'siteCustom.RoomActivitiesRate',
  },
  {
    value: nameResultsOrder['Activities, Rate, Room'],
    label: 'siteCustom.ActivitiesRateRoom',
  },
  {
    value: nameResultsOrder['nameResultOrder'],
    label: 'siteCustom.NameResultOrder',
  },
]

export const RoleOptions = [
  { value: Role['Front-Desk'], label: 'accSettings.role.frontDesk' },
  { value: Role['Editor'], label: 'accSettings.role.editor' },
  { value: Role['Organizator'], label: 'accSettings.role.organization' },
  { value: Role['Reseller'], label: 'accSettings.role.reseller' },
  { value: Role['Internal'], label: 'accSettings.role.internal' },
]

export enum Status {
  'Active' = 'Active',
  'Paused' = 'Paused',
  'Archived' = 'Archived',
}

export const StatusOptions = [
  { value: Status.Active, label: 'rates.create.active' },
  { value: Status.Paused, label: 'rates.create.paused' },
]

export enum ExtraChargesType {
  'once' = 'once',
  'perNight' = 'perNight',
  'perPerson' = 'perPerson',
  'perNightPerPerson' = 'perNightPerPerson',
}

export const ExtraChargesTypeOptions = [
  { value: ExtraChargesType.once, label: 'rate.once' },
  { value: ExtraChargesType.perNight, label: 'rate.perNight' },
  { value: ExtraChargesType.perPerson, label: 'rate.perPerson' },
  {
    value: ExtraChargesType.perNightPerPerson,
    label: 'rate.perNightPerPerson',
  },
]

export type Country = {
  name: string
  iso2: string
}

export type City = {
  name: string
  id: number
}

export type State = {
  name: string
  id: number
}

export const RestrictionTypeTranslation = {
  [RestrictionType.Stay]: 'propertyRestrictions.closedForStay',
  [RestrictionType.End]: 'propertyRestrictions.closedOnDeparture',
  [RestrictionType.Start]: 'propertyRestrictions.closedOnArrival',
}
